<template>
    <div class="my-5">
        <PriceSpecificationFerry :product="product" />
    </div>
</template>
<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { FerryProduct } from '@/api/Cart/cart.interfaces';
    import PriceSpecificationFerry from '@/components/shared/PriceSpecification/Ferry/PriceSpecificationFerry.vue';

    export default defineComponent({
        name: 'FerryModalPrice',
        components: { PriceSpecificationFerry },
        props: {
            product: {
                type: Object as PropType<FerryProduct>,
                required: true,
            },
        },
    });
</script>
